import { render, staticRenderFns } from "./WinPrize.vue?vue&type=template&id=6ce7b13b&scoped=true&"
import script from "./WinPrize.vue?vue&type=script&lang=js&"
export * from "./WinPrize.vue?vue&type=script&lang=js&"
import style0 from "./WinPrize.vue?vue&type=style&index=0&id=6ce7b13b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce7b13b",
  null
  
)

component.options.__file = "WinPrize.vue"
export default component.exports